function getCityFromAddress(address?: { city?: string | null } | null) {
  if (!address || !address.city) return undefined;
  const firstLetter = address.city.split(' ')[0];
  return firstLetter === 'г' ? address.city.split(' ')[1] : address.city;
}

export default getCityFromAddress;
